import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
  forwardRef,
  ViewEncapsulation
} from "@angular/core";
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from "@angular/forms";
import { ContactCardComponent } from "@hub/components/v1/_common/contact-cards/contact-card.component";
import { FormEventService } from "@hub/services/form-event.service";
import { AutoComplete } from 'primeng/autocomplete';
import { Subject, Subscription } from "rxjs";
import { BaseErrorForm } from "@hub/common/BaseErrorForm";
import { eContactCardType, eClientStatus } from "@hub/generated/enums";
import { Functions } from "@hub/common/Functions";
import { ContactCardDto } from "@hub/generated/models";

const noop = () => {};

export const CUSTOM_INPUTCONPIC_CONTROL_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => FormContactpickerV2Component),
  multi: true
};

@Component({
  selector: "fm-contactpicker-v2",
  templateUrl: "form-contactpicker.component.html",
  styleUrls: ["form-contactpicker.component.scss"],
  encapsulation: ViewEncapsulation.None,
  providers: [CUSTOM_INPUTCONPIC_CONTROL_VALUE_ACCESSOR],
})
export class FormContactpickerV2Component extends BaseErrorForm
  implements ControlValueAccessor, OnInit, OnDestroy {
  constructor(
    private el: ElementRef,
    public formEventService: FormEventService
  ) {
    super();
  }

  @Output() completeMethod: EventEmitter<any> = new EventEmitter();
  @Output() onDropdownClick: EventEmitter<any> = new EventEmitter();
  @Output() onSelectValue: EventEmitter<any> = new EventEmitter();
  @Output() onClearMethod: EventEmitter<any> = new EventEmitter();
  @Output() ngModelChange: EventEmitter<any> = new EventEmitter();
  @Output() advancedSearch: EventEmitter<any> = new EventEmitter();

  isNotObject: boolean;
  isEdit: boolean = true;
  isOnClear: boolean = false;
  initialValue: ContactCardDto;
  contactCardDescription: string = "";
  results: Subject<Array<object>> = new Subject<Array<object>>();
  getClicks: Subscription;
  @Input() placeholder: "Search";
  @Input() forceSelection: boolean = false;
  @Input() resetBtn: boolean = true;
  @Input() isMultiple: boolean = false;
  @Input() isVenue: boolean = false;
  @Input() isAdvancedSearch: boolean = false;
  @Input() isAdvancedSearchDialog: boolean = false;
  @Input() isAdvancedSearchAssociateSelection: boolean = false;
  @Input() public disabled: boolean = false;
  @Input() public enableTooltip: boolean = true;
  @Input() public onSearchIconClick: Function = null;

  // defaultUserAvatar:string='<i class="far fa-user"></i>'
  tabindex: string;
  @Input("tabindex")
  set tabin(val: string) {
    this.tabindex = String(val);
  }

  private display: boolean = false;
  private clickEvent: Subject<boolean> = new Subject<boolean>();
  private innerValue: any = "";
  private isSearchClick: boolean = false;
  private searchCharacter: string = "";
  private resultCount: number = 0;
  private setContactCard: boolean = true;

  // Placeholders for the callbacks which are later provided
  // by the Control Value Accessor
  private onTouchedCallback: () => void = noop;
  private onChangeCallback: (_: any) => void = noop;

  @ViewChild(ContactCardComponent) contactCard: ContactCardComponent;
  @ViewChild("content", { read: ElementRef })
  private content: ElementRef;

  @ViewChild("autoComplete") autoComplete: AutoComplete;

  @Input("suggestions")
  set suggestions(val: Array<object>) {
    this.results.next(val);
  }

  ngOnInit() {
    this.formEventService.setIndex(parseInt(this.tabindex));
    this.getClicks = this.clickEvent.subscribe(x => {
      setTimeout(() => {
        const element: HTMLElement = this.el.nativeElement.querySelector(
          "input"
        );
        if (element != null) {
          element.focus();
        }
      }, 0);
    });
  }

  ngOnDestroy() {
    this.results.complete();
    if (this.getClicks) {
      this.getClicks.unsubscribe();
    }
  }

  handleDropdown(event: any) {
    event.originalEvent.stopPropagation();
    this.onDropdownClick.emit(event);
  }

  search(event: any) {
    this.searchCharacter = event.query;
    this.completeMethod.emit(event);
  }

  changeValue() {
    this.ngModelChange.emit();
  }

  get value(): any {
    if (this.innerValue && this.setContactCard) {
      setTimeout(() => {
        this.isEdit = false;
        this.setContactCard = false;
        this.initialValue = this.innerValue;
      }, 30);
    }
    return this.innerValue;
  }

  // set accessor including call the onchange callback
  set value(v: any) {
    if (v !== this.innerValue) {
      this.innerValue = v;
      this.onChangeCallback(v);
      if (v) {
        if (v.Id) {
          this.isNotObject = false;
        } else {
          this.isNotObject = true;
        }
      }
    }
    if (v == "") {
      this.isNotObject = false;
    }
    this.isEdit = true;
  }

  onClick(event: MouseEvent) {
    event.stopPropagation();
    this.formEventService.changeFocus(this.tabindex);
    this.clickEvent.next(true);
    // this.formEventService.setFocusIn(true);
  }

  resetValue(event: any): void {
    this.writeValue(event);
    this.onChangeCallback(event);
  }

  // Set touched on blur
  onBlur(event) {
    this.validateResulObject();
    this.onTouchedCallback();
  }

  onClear(event: Event) {
    this.isOnClear = true;
    this.resetValue(null);
    this.onClearMethod.emit(event);
  }

  onSelect(event: Event) {
    this.isOnClear = false;
    this.onSelectValue.emit(event);
    if (this.isAdvancedSearchAssociateSelection) {
      setTimeout(() => {
        this.isOnClear = true;
        this.resetValue(null);
      }, 10);
    } else {
      this.writeValue(event);
      this.onChangeCallback(event);
      setTimeout(() => {
        this.isEdit = !this.isMultiple ? false : true;
      }, 10);
    }
  }

  onFocus(event: Event) {
    this.onTouchedCallback();
  }

  onSearchIconClickHandler(event: Event) {
    if (!!this.isAdvancedSearch) {
      // this.onSearchIconClick();
      if (this.isSearchClick) {
        this.advancedSearch.emit(event);
      }
    } else {
      this.setFocusOutValues();
      this.isSearchClick = false;
    }
  }

  setFocusOutValues() {
    if (this.initialValue && this.innerValue) {
      this.isEdit = false;
    }
    if (!this.innerValue && !this.isEdit) {
      this.resetValue(this.initialValue);
    } else if (!this.innerValue) {
      this.resetValue(null);
    }
  }

  // From ControlValueAccessor interface
  writeValue(value: any) {
    if (value !== this.innerValue) {
      if (value != undefined || this.isOnClear) {
        this.innerValue = value;
        this.isOnClear = false;
      }
    }
    if (value && value.Id) {
      this.isNotObject = false;
    }
  }

  // From ControlValueAccessor interface
  registerOnChange(fn: any) {
    this.onChangeCallback = fn;
  }

  // From ControlValueAccessor interface
  registerOnTouched(fn: any) {
    this.onTouchedCallback = fn;
  }

  private validateResulObject() {
    if (typeof this.value === "string" && this.value !== "") {
      if (this.control && this.control.setErrors) {
        this.control.setErrors({ objectRequired: true });
      }
    }
  }

  focusOut(event) {
    if (!this.isAdvancedSearchAssociateSelection) {
      setTimeout(
        () => {
          if (this.initialValue && this.innerValue) {
            this.isEdit = false;
          }
          if (!this.innerValue && !this.isEdit) {
            this.resetValue(this.initialValue);
          } else if (!this.innerValue) {
            this.resetValue(null);
          }
        },
        this.isAdvancedSearch ? 151 : 10
      );
    }
  }

  public switchToEditing(event: any) {
    this.isEdit = true;
    setTimeout(() => {
      this.autoComplete.focusInput();
    }, 10);
  }

  public setContactCardDescription() {
    if (this.value) {
      if (this.value.ContactType == eContactCardType.Client) {
        this.contactCardDescription = Functions.getEnumName(
          eClientStatus,
          this.value.ClientStatus
        );
      } else if (this.value.ContactType == eContactCardType.Buyer) {
        this.contactCardDescription = this.value.BuyerMarket;
      } else if (this.value.ContactType == eContactCardType.Venue) {
        this.contactCardDescription =
          this.value.Address.City +
          " " +
          this.value.Address.State +
          " " +
          this.value.Address.PostalCode;
      } else if (this.value.ContactType == eContactCardType.Agent) {
        this.contactCardDescription =
          this.value.Extension + " " + this.value.Address.PostalCode;
      }
    }
  }
}
